var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRulerVertical(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M208 0H48C21.6 0 0 21.6 0 48V464C0 490.4 21.6 512 48 512H208C234.4 512 256 490.4 256 464V48C256 21.6 234.4 0 208 0ZM240 104H160C155.594 104 152 107.578 152 112S155.594 120 160 120H240V200H160C155.594 200 152 203.578 152 208S155.594 216 160 216H240V296H160C155.594 296 152 299.578 152 304S155.594 312 160 312H240V392H160C155.594 392 152 395.578 152 400S155.594 408 160 408H240V464C240 481.645 225.645 496 208 496H48C30.355 496 16 481.645 16 464V48C16 30.355 30.355 16 48 16H208C225.645 16 240 30.355 240 48V104Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRulerVertical);
export default __webpack_public_path__ + "static/media/ruler-vertical.4f8e3d1c0125faa469570777a9166af5.svg";
export { ForwardRef as ReactComponent };